module.exports = __webpack_public_path__ + "bdb952dbbb3ce511174b12c95280f63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-320.jpg
// module id = 575
// module chunks = 0